/**
 * @fileoverview which user-management controls a developer may use, given the Delete Dashboard Users flipper
 */

import type { DashboardUserDeleteChecks, DashboardUserPermissionChecks } from "./types";

/**
 * Whether a developer of a regular (non-free-trial) company may open user management.
 * Edit Dashboard Users always qualifies; with the flipper on, Delete Dashboard Users does too.
 */
export const canAccessDashboardUserManagement = ({
  featureOn,
  hasPermissionForAnyScope,
}: DashboardUserPermissionChecks): boolean =>
  hasPermissionForAnyScope("editDashboardUsers") ||
  (featureOn("clip_delete_dashboard_users_permission") && hasPermissionForAnyScope("deleteDashboardUsers"));

/**
 * Whether the add and edit controls inside user management show.
 * With the flipper off, the page gate already required Edit Dashboard Users, so they always show.
 */
export const canEditDashboardUsers = ({
  featureOn,
  hasPermissionForAnyScope,
}: DashboardUserPermissionChecks): boolean =>
  !featureOn("clip_delete_dashboard_users_permission") || hasPermissionForAnyScope("editDashboardUsers");

/**
 * Whether the delete controls for a regular (non-free-trial) developer show.
 * With the flipper on this is the company-scoped Delete Dashboard Users permission; with it off, company admin only.
 */
export const canDeleteDashboardUsers = ({
  featureOn,
  hasPermissionForAnyScope,
  isCompanyAdmin,
}: DashboardUserDeleteChecks): boolean =>
  featureOn("clip_delete_dashboard_users_permission")
    ? hasPermissionForAnyScope("deleteDashboardUsers")
    : isCompanyAdmin;
